import { Navigate, useLocation } from 'react-router-dom';
import { isLoggedIn } from '../auth';

export default function PrivateRoute({ children }) {
    const location = useLocation();
    if (isLoggedIn()) return children;
    return <Navigate to="/login" state={{ from: location }} replace />;
}
